import {
  Box,
  Tab,
} from '@chakra-ui/react';
import Link from 'next/link';
import { Image } from '@/components/Image';
import { ReturnPageInfo } from '@/config/pages';

type ShopDetailTabsSpItemProps = {
  isActive: boolean;
  menuLink: ReturnPageInfo;
  isDisabledCourseTab: boolean;
  isDisabledStaffsTab: boolean;
  isDisabledMessageTab: boolean;
  isDisabledBlogTab: boolean;
  tabIcon: string;
  tabIconAlt: string;
  activeTabIcon: string;
  tabMenuTitle: string;
}

export const ShopDetailTabsSpItem = ({
  isActive = false,
  menuLink,
  tabIcon,
  activeTabIcon,
  tabIconAlt,
  isDisabledCourseTab,
  isDisabledStaffsTab,
  isDisabledMessageTab,
  isDisabledBlogTab
}: ShopDetailTabsSpItemProps) => {
  const isDisabled = isDisabledCourseTab || isDisabledStaffsTab || isDisabledMessageTab || isDisabledBlogTab;

  return (
    <Box
      w={'20%'}
    >
      <Link
        href={menuLink.href}
      >
        <Tab
          _focus={{ boxShadow: 'none' }}
          _selected={{
            color: 'brand.500',
            borderBottom: 'none',
          }}
          color={'brandSecondary.500'}
          bg={'white'}
          cursor={'pointer'}
          disabled={isDisabled}
          pointerEvents={isDisabled ? 'none' : 'auto'}
          fontWeight={'bold'}
          alignItems={'center'}
          justifyContent={'center'}
          textAlign={'center'}
          pt={2}
          px={1}
          pb={0}
          w={'full'}
        >
          <Image
            src={isActive ? activeTabIcon : tabIcon}
            alt={tabIconAlt}
            width={75}
            height={67}
          />
        </Tab>
      </Link>
    </Box>
  );
};
